import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the condition",
    opening: localizedGenderNode(
      [
      "Today I don't try to change it.",
      "I just notice the condition I live with.",
      "That is enough for now."
    ],
      [
      "Today I don't try to change it.",
      "I just notice the condition I live with.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel I am good only if I succeed?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When do I feel I am good only if I succeed?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing the condition is already a beginning."
    ],
      [
      "Noticing the condition is already a beginning."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Where it came from",
    opening: localizedGenderNode(
      [
      "Today I notice where the condition came from.",
      "Without blame.",
      "Just to see."
    ],
      [
      "Today I notice where the condition came from.",
      "Without blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I first hear this message?",
      "Who or what reinforced it?",
      "What did it do to me then?"
    ],
      [
      "When did I first hear this message?",
      "Who or what reinforced it?",
      "What did it do to me then?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the source softens the present."
    ],
      [
      "Seeing the source softens the present."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the source.",
      "write one word about the source."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What I am trying to prove",
    opening: localizedGenderNode(
      [
      "Today I ask what I'm trying to prove.",
      "Not criticism.",
      "Curiosity."
    ],
      [
      "Today I ask what I'm trying to prove.",
      "Not criticism.",
      "Curiosity."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to prove when I succeed?",
      "Who am I trying to show?",
      "What would I want them to see in me without achievements?"
    ],
      [
      "What am I trying to prove when I succeed?",
      "Who am I trying to show?",
      "What would I want them to see in me without achievements?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Proving is sometimes an attempt to receive love."
    ],
      [
      "Proving is sometimes an attempt to receive love."
    ]
    ),
    action: localizedGenderNode(
      "write one truth about me without an achievement.",
      "write one truth about me without an achievement."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The part that fears mistakes",
    opening: localizedGenderNode(
      [
      "Today I notice the part that fears mistakes.",
      "Not to fight.",
      "Just to be with it."
    ],
      [
      "Today I notice the part that fears mistakes.",
      "Not to fight.",
      "Just to be with it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I feel this fear in my body?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ],
      [
      "Where do I feel this fear in my body?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with it for a moment is already a small change."
    ],
      [
      "Being with it for a moment is already a small change."
    ]
    ),
    action: localizedGenderNode(
      "place a hand on my heart and breathe.",
      "place a hand on my heart and breathe."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The cost of the condition",
    opening: localizedGenderNode(
      [
      "Today I see the cost of the condition.",
      "Not to blame.",
      "Just to see."
    ],
      [
      "Today I see the cost of the condition.",
      "Not to blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the price I pay for this condition?",
      "What do I lose along the way?",
      "What would I want to be different?"
    ],
      [
      "What is the price I pay for this condition?",
      "What do I lose along the way?",
      "What would I want to be different?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Seeing the cost opens space for a small change."
    ],
      [
      "Seeing the cost opens space for a small change."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the cost.",
      "write one word about the cost."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Asking for gentleness",
    opening: localizedGenderNode(
      [
      "Today I form a small request for gentleness.",
      "Not big.",
      "Just small."
    ],
      [
      "Today I form a small request for gentleness.",
      "Not big.",
      "Just small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I want to be spoken to when I make a mistake?",
      "How can I speak that way to myself?",
      "What is a small step toward it?"
    ],
      [
      "How would I want to be spoken to when I make a mistake?",
      "How can I speak that way to myself?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small gentleness can open a breath."
    ],
      [
      "A small gentleness can open a breath."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Being worthy even without",
    opening: localizedGenderNode(
      [
      "Today I check what it's like to be worthy even without achievement.",
      "Just a moment.",
      "No more."
    ],
      [
      "Today I check what it's like to be worthy even without achievement.",
      "Just a moment.",
      "No more."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is good in me even without achievements?",
      "How does it feel to say that?",
      "What am I afraid will happen if I believe it?"
    ],
      [
      "What is good in me even without achievements?",
      "How does it feel to say that?",
      "What am I afraid will happen if I believe it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One good word can be an anchor."
    ],
      [
      "One good word can be an anchor."
    ]
    ),
    action: localizedGenderNode(
      "say one good word about me.",
      "say one good word about me."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A boundary with demands",
    opening: localizedGenderNode(
      [
      "Today I check a small boundary with demands.",
      "Not to distance.",
      "Just to protect."
    ],
      [
      "Today I check a small boundary with demands.",
      "Not to distance.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where is the demand strongest on me?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ],
      [
      "Where is the demand strongest on me?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary protects the heart."
    ],
      [
      "A small boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Asking for warmth",
    opening: localizedGenderNode(
      [
      "Today I check how to ask for warmth.",
      "No drama.",
      "A small request."
    ],
      [
      "Today I check how to ask for warmth.",
      "No drama.",
      "A small request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What warmth do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What warmth do I miss?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can soften things."
    ],
      [
      "One request can soften things."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Staying with myself",
    opening: localizedGenderNode(
      [
      "Today I practice staying with myself when I don't succeed.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice staying with myself when I don't succeed.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ],
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is a small repair."
    ],
      [
      "Staying with me is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one breath after a small mistake.",
      "one breath after a small mistake."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One value beyond achievement",
    opening: localizedGenderNode(
      [
      "Today I look for one value beyond achievement.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value beyond achievement.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value stays even without achievements?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value stays even without achievements?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value is an anchor."
    ],
      [
      "One value is an anchor."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Listening to me",
    opening: localizedGenderNode(
      [
      "Today I practice listening to me.",
      "Even when there is no success.",
      "Even then."
    ],
      [
      "Today I practice listening to me.",
      "Even when there is no success.",
      "Even then."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ],
      [
      "What do I need to hear from myself today?",
      "What do I give others that I don't give me?",
      "How can I give it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Listening to me is a small repair."
    ],
      [
      "Listening to me is a small repair."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of acceptance",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of acceptance.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to love that isn't conditional.",
      "When I fall.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to love that isn't conditional.",
      "When I fall.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this condition?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this condition?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can make mistakes and still stay with myself."
    ],
      [
      "I can make mistakes and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const conditionalLoveGoodOnlyIfISucceedBlueprintEn = buildNormalizedPilotBlueprint({
  id: "conditional_love_good_only_if_i_succeed_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "conditional_love_good_only_if_i_succeed",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "אהבה על תנאי (טוב רק אם אני מצליח/ה)",
    en: "Conditional love (good only if I succeed)",
    es: "Amor condicional (solo soy bueno/a si tengo éxito)",
  },
  days,
});

export default conditionalLoveGoodOnlyIfISucceedBlueprintEn;
